import { useNavigate } from "react-router-dom";

const images = [
  "1.jpg",
  "2.jpg",
  "3.jpg",
  "4.jpg",
  "5.jpg",
  "6.jpg",
  "7.jpg",
  "8.jpg",
  "9.jpg",
  "10.jpg",
];

export default function ItaliaPage() {
  const navigate = useNavigate();

  function PhotoGrid({ images, folder }) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {images.map((img, idx) => (
          <div
            key={img}
            className="aspect-square overflow-hidden rounded-lg shadow-lg bg-white flex items-center justify-center hover:scale-105 transition-transform duration-200"
          >
            <img
              src={
                `/proiecte/Erasmus+/pozeItalia/${img}`
              }
              alt={`Italia Erasmus ${idx + 1}`}
              className="object-cover w-full h-full"
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <h1 className="text-2xl font-bold mb-4 text-center">
          Întâlnire de lucru în Formia, Italia, în cadrul proiectului Erasmus+
          KA229 „OUR PAST OUR FUTURE“
        </h1>
        <p className="mb-4">
          Ultima activitate de învățare din cadrul Proiectului Erasmus+" Our
          past our future" a avut loc în Italia, elevii și profesorii fiind
          foarte încântați de experienta trăită.
        </p>
        <PhotoGrid
          images={images}
          folder="proiecte/erasmus+/pozeItalia"
          altPrefix="Italia Erasmus"
        />
        <button
          onClick={() => navigate("/proiecte/erasmus+")}
          className="m-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 float-right"
        >
          &larr; Înapoi
        </button>
      </main>
    </div>
  );
}
